export default "__VITE_ASSET__Mw$ZWUBc__"